/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.11.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { fonts } from '../../../../../../theme';
import { IAttrStyled } from '../../../../../../types/globalTypes';

export const ControlBlockStyled = styled.div.attrs((props: IAttrStyled) => ({
    className: `ext-filter__control-block ${props.className || ''}`,
    id: 'ext-filter-control-block',
}))`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px 24px;
`;

export const SaveBlockStyled = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;

export const SavedFiltersContainerStyled = styled.div.attrs({
    'className': 'ext-filter__saved-filters',
    'data-extended-filter-saved-filters': 'extendedFilterSavedFilters',
})`
    min-width: 416px;
`;

export const SaveButtonStyled = styled.div.attrs(() => ({
    'className': 'ext-filter__action-button ext-filter__save-button',
    'id': 'ext-filter-save-button',
    'data-extended-filter-save-button': 'extendedFilterSaveButton',
}))`
    margin-left: 16px;
`;

export const DeleteBlockStyled = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;

export const DeleteButtonStyled = styled.div.attrs((props: IAttrStyled) => ({
    'className': `ext-filter__action-button ext-filter__delete-button ${props.className || ''}`,
    'id': 'ext-filter-delete-button',
    'data-extended-filter-delete-button': 'extendedFilterDeleteButton',
}))`
    ${fonts.textLink};
    cursor: pointer;
    margin-left: 16px;
`;
